import { CardSize } from "../types/constants";

export function isCardLarge(size: CardSize | undefined) {
    return size === CardSize.LARGE;
}

export function ensureArray<T>(value: unknown): T[] {
    return Array.isArray(value) ? (value as T[]) : [];
}
